import { setCMSBarWidth } from './cms-bar-width'
import { appendVersions } from './site-common'

document.addEventListener('DOMContentLoaded', () => {
    /* Menu control */
    const body = document.getElementsByTagName('BODY')[0]
    const toggleMenu = document.getElementById('toggleMenu')
    const openMenu = document.getElementById('openMenu')
    const closeMenu = document.getElementById('closeMenu')

    function menu(element, add) {
        toggleMenu.addEventListener('click', function() {
            element.classList.toggle(add)
        })
    }

    menu(body, 'show-body')
    menu(openMenu, 'hide-icon')
    menu(closeMenu, 'show-icon')

    const structure = document.querySelector('.cms-toolbar-item-cms-mode-switcher > a:not(.cms-btn-disabled)')
    if (structure) {
        structure.addEventListener('click', () => {setTimeout(setCMSBarWidth, 1000)}, true)
    }

    appendVersions(document.querySelector('.cms-toolbar-item-logo a'))

})
